import React from 'react';

import { Button, UIText2 } from '@cian/ui-kit';
import { ETestIds } from '../../constants';
import { useAuthAction } from '../../hooks/useAuthAction';
import { useTracking } from '../../utils/tracking/useTracking';

import * as styles from './styles.css';

export const ActionsContainer: React.FC = () => {
  const { trackClickOnTargetButton } = useTracking();
  const { isLoading, handleAuthAction } = useAuthAction({
    trackingFunction: trackClickOnTargetButton,
  });

  return (
    <div className={styles['btn']}>
      <div className={styles['wrapper']}>
        <Button
          size="M"
          onClick={handleAuthAction}
          loading={isLoading}
          disabled={isLoading}
          data-testid={ETestIds.MainButton}
        >
          Заполнить заявку на Циане
        </Button>
        <UIText2 color={'text-secondary-default'}>Заявка единая для всех банков</UIText2>
      </div>
    </div>
  );
};
